import { render, staticRenderFns } from "./DeleteDraftWindow.vue?vue&type=template&id=47613ab0&scoped=true"
import script from "./DeleteDraftWindow.vue?vue&type=script&lang=js"
export * from "./DeleteDraftWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47613ab0",
  null
  
)

export default component.exports